import { render, staticRenderFns } from "./StudyUnitInformation.vue?vue&type=template&id=1975ecde&scoped=true&lang=pug&"
import script from "./StudyUnitInformation.vue?vue&type=script&lang=ts&"
export * from "./StudyUnitInformation.vue?vue&type=script&lang=ts&"
import style0 from "./StudyUnitInformation.vue?vue&type=style&index=0&id=1975ecde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1975ecde",
  null
  
)

export default component.exports